module.exports = __webpack_public_path__ + "img/1.13935e2.png";